export const  ProjectRoutes = {
    createProject: "/project/create",
    getProject: "/project/getAll",
    getProjectsWithHours: "/auth/getProjectHoursAndUsers",
    assignProject: "/project/assignUser",
    updateProject:"/project/updateProject",
     deleteProject:"/project/deleteProject",
    deleteAssignedUser:"/project/removeAssignedUsers"
  };
    